import { useSelector } from "react-redux";
import { FEATURE_FLAGS } from "../constants/FeatureFlag";
import useFeatureFlag from "./useFeatureFlag";
import useSubscriptionStatus from "./useSubscriptionStatus";

const getCreditsStatus = ({
  isLoadingCredits,
  hasSubscription,
  hasBonus,
}) => {
  if (isLoadingCredits) {
    return {
      isRestricted: false,
      isLoading: true,
    };
  }

  const hasAccess = hasSubscription || hasBonus;

  return {
    hasJusProcessos: true,
    isRestricted: !hasAccess,
    isLoading: false,
  };
};

const useCredits = () => {
  const creditsState = useSelector((state) => state.credits);
  const subscriptionState = useSelector(
    (state) => state.subscription.subscription_status,
  );

  const hasSubscription = creditsState?.credits?.hasSubscription ?? false;
  const hasBonus = creditsState?.credits?.hasBonus ?? false;
  const isLoadingCredits = creditsState?.isLoading ?? false;

  const { isLoading: isLoadingSubscription } = useSubscriptionStatus();
  const { isFeatureFlagEnable, flagResolved } = useFeatureFlag(
    FEATURE_FLAGS.KILL_SWITCH.ENABLE_CREDIT_CARD_REGULARIZATION,
  );

  const creditsResult = getCreditsStatus({
    isLoadingCredits,
    hasSubscription,
    hasBonus,
  });

  const regularization = subscriptionState?.regularization;

  const isInRegularizationPeriod =
    !creditsResult.isLoading &&
    !creditsResult.isRestricted &&
    !isLoadingSubscription &&
    Boolean(regularization?.canRegularize);

  const showRegularizationCta =
    isInRegularizationPeriod &&
    (regularization?.canRegularizeWithCard
      ? flagResolved && isFeatureFlagEnable
      : true);

  return {
    ...creditsResult,
    isSubscriptionStatusLoading: isLoadingSubscription,
    isInRegularizationPeriod,
    showRegularizationCta,
  };
};

export default useCredits;
